"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameCollections = void 0;
var GameCollections_1 = require("./GameCollections");
Object.defineProperty(exports, "GameCollections", { enumerable: true, get: function () { return __importDefault(GameCollections_1).default; } });
